module.exports = __webpack_public_path__ + "img/kbank.f7f6d66c.svg";